<div [attr.data-testid]="settings.id" class="datiq-cell-lane">
    <div class="datiq-cell-lane__container datiq-cell-lane__container--icon h-10">
        <mat-icon
            class="datiq-cell-lane__icon"
            [svgIcon]="'app:orig-dest-vertical'"
            [attr.data-testid]="settings.id + '-icon'"
        ></mat-icon>
    </div>
    <div class="datiq-cell-lane__container datiq-cell-lane__container--label font-body-2">
        <span
            datiqTruncate
            (datiqTruncateEllipsed)="isOriginTruncated = $event"
            [attr.data-testid]="settings.id + '-origin'"
            [matTooltip]="settings?.origin?.displayName"
            [matTooltipDisabled]="!isOriginTruncated"
            class="datiq-cell-lane__label datiq-cell-lane__label--origin"
        >
            {{ settings?.origin?.displayName ?? DEFAULT_LABEL }}
        </span>
        <span
            class="datiq-cell-lane__label datiq-cell-lane__label--destination font-body-2"
            datiqTruncate
            [attr.data-testid]="settings.id + '-destination'"
            (datiqTruncateEllipsed)="isDestinationTruncated = $event"
            [matTooltip]="settings?.destination?.displayName"
            [matTooltipDisabled]="!isDestinationTruncated"
        >
            {{ settings?.destination?.displayName ?? DEFAULT_LABEL }}
        </span>
    </div>
</div>
